import type { IWindowBranding } from '@erp/native/interfaces';

/**
 * Web fallback — best-effort favicon swap. The OS chrome (browser tab
 * icon) is the closest analogue to a desktop title-bar icon. We rewrite
 * the <link rel=icon> to point at a blob URL of the supplied bytes, so
 * the user's tenant logo appears on the browser tab.
 */
export function createWebWindowBranding(): IWindowBranding {
  let lastBlobUrl: string | null = null;
  const ensureLink = (): HTMLLinkElement => {
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.append(link);
    }
    return link;
  };
  const cleanupBlob = () => {
    if (lastBlobUrl) {
      URL.revokeObjectURL(lastBlobUrl);
      lastBlobUrl = null;
    }
  };
  return {
    async setIcon(image) {
      cleanupBlob();
      const link = ensureLink();
      if (!image) {
        link.removeAttribute('href');
        return;
      }
      const blob = new Blob([new Uint8Array(image)]);
      const url = URL.createObjectURL(blob);
      link.href = url;
      lastBlobUrl = url;
    },
    async setIconFromUrl(url) {
      cleanupBlob();
      ensureLink().href = url;
    },
    async setTitle(title) {
      document.title = title;
    },
  };
}
